console.log('[dm] script loaded');

(() => {
  const sheet = new CSSStyleSheet();
  sheet.replaceSync('video,img,canvas{filter:invert(1) hue-rotate(180deg)!important}');
  const roots = new Set();
  let queued = false;

  const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(sync); } };

  const scan = root => root.querySelectorAll('*').forEach(el => {
    const sr = el.shadowRoot;
    if (!sr) return;
    if (!roots.has(sr)) {
      roots.add(sr);
      new MutationObserver(schedule).observe(sr, { childList: true, subtree: true });
    }
    scan(sr);
  });

  function sync() {
    queued = false;
    scan(document);
    const on = document.documentElement.dataset.darkModeActive === 'true';
    roots.forEach(r => {
      const has = r.adoptedStyleSheets.includes(sheet);
      if (on && !has) r.adoptedStyleSheets = [...r.adoptedStyleSheets, sheet];
      else if (!on && has) r.adoptedStyleSheets = r.adoptedStyleSheets.filter(s => s !== sheet);
    });
  }

  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true, subtree: true,
    attributes: true, attributeFilter: ['data-dark-mode-active']
  });
  schedule();
})();